import { z } from 'zod';
import { idempotency } from './spine';

/** Manual (cash/check) payment recorded against an invoice — the credential-free path. */
export const manualPaymentMethod = z.enum(['cash', 'check', 'other']);

export const recordManualPaymentInput = idempotency.extend({
  invoiceId: z.string().uuid(),
  amountCents: z.coerce.number().int().positive().max(100_000_000),
  method: manualPaymentMethod,
  receivedAt: z.coerce.date().optional(),
  reference: z.string().trim().max(120).optional().or(z.literal('')),
  /** Money handed over ON TOP of the invoice. Never folded into amountCents — see the
   *  payments table comment: a tipped invoice would otherwise read as overpaid. */
  tipCents: z.coerce.number().int().min(0).max(100_000_000).optional(),
  /** Whose tip. Defaults to whoever recorded it, which at the door is the tech. */
  tipForUserId: z.string().uuid().optional(),
});
export type RecordManualPaymentInput = z.infer<typeof recordManualPaymentInput>;

export const refundInput = idempotency.extend({
  paymentId: z.string().uuid(),
  amountCents: z.coerce.number().int().positive().max(100_000_000),
  reason: z.string().trim().max(500).optional().or(z.literal('')),
});
export type RefundInput = z.infer<typeof refundInput>;

/** Stripe pay path (M3 live — requires STRIPE_SECRET_KEY; the adapter is inert without it). */
export const stripePaymentIntentInput = idempotency.extend({
  invoiceId: z.string().uuid(),
  method: z.enum(['card', 'ach']),
});
export type StripePaymentIntentInput = z.infer<typeof stripePaymentIntentInput>;
